import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';
import FeatherIcon from 'feather-icons-react';
import { getCssVariable } from '@utils/index';

type Props = {
  user: any;
  userRequestedData: any;
  voiceEnabled?: boolean;
};
export default function WhatsNext({
  userRequestedData,
  user,
  voiceEnabled,
}: Props) {
  const { t } = useTranslation('dashboard');

  const step1Done = voiceEnabled || userRequestedData?.length > 0;

  return (
    <div className={styles.container}>
      <div className={styles.step}>
        <div
          className={`${styles.icon} ${
            step1Done ? styles.icon1Selected : styles.icon1
          } `}
        >
          <FeatherIcon
            strokeWidth="2px"
            color={getCssVariable('white')}
            icon={step1Done ? 'check' : 'bookmark'}
            size="20"
          />
        </div>
        <div
          className={`${styles.content} ${
            step1Done ? styles.done : styles.toDo
          }`}
        >
          <p className="sub-header">{t('whatsNext.step1')}</p>
        </div>
      </div>
      <div className={styles.step}>
        <div
          className={`${styles.icon} ${
            voiceEnabled
              ? styles.icon2Completed
              : userRequestedData?.length > 0
                ? styles.icon2Selected
                : styles.icon2
          }`}
        >
          <FeatherIcon
            strokeWidth="2px"
            color={getCssVariable(
              voiceEnabled || userRequestedData?.length > 0 ? 'white' : 'orange'
            )}
            icon={voiceEnabled ? 'check' : 'message-square'}
            size="20"
          />
        </div>
        <div
          className={`${styles.content} ${
            voiceEnabled
              ? styles.done
              : userRequestedData?.length > 0
                ? styles.toDo
                : styles.opacity
          }`}
        >
          <p className="sub-header bolder">{t('whatsNext.step2.title')}</p>
          {(voiceEnabled || userRequestedData?.length > 0) && (
            <p className="extra-small" style={{ fontWeight: '400' }}>
              {t('whatsNext.step2.description', {
                name: user?.displayName?.split(' ')[0],
              })}
            </p>
          )}
        </div>
      </div>
      <div className={styles.step}>
        <div
          className={`${styles.icon} ${
            voiceEnabled ? styles.icon3Completed : styles.icon3
          }`}
        >
          <FeatherIcon
            strokeWidth="2px"
            color={getCssVariable(voiceEnabled ? 'white' : 'orange')}
            icon={voiceEnabled ? 'check' : 'heart'}
            size="20"
          />
        </div>
        <div
          className={`${styles.content} ${
            voiceEnabled ? styles.done : styles.opacity
          }`}
        >
          <p className="sub-header">{t('whatsNext.step3')}</p>
        </div>
      </div>
    </div>
  );
}
